import Service from "../AuthService";

const powerBi = {

    getAllPowerBi() {
        return Service.get(`/api/power-bi/all`);
    },
    // addPowerBi(data) {
    //     return Service.post(`/api/power-bi/` + data.name, {
    //         embed_url: data.embed_url,
    //         description: data.description
    //     }, {
    //         headers: { Authorization: `Bearer ${data.token}` }
    //     });
    // },
    updatePowerBi(data) {
        return Service.post(`/api/power-bi/update`,data )
        //     , {data,
        //     headers: { Authorization: `Bearer ${data.userData.token}` }
        // });
    },
    deletePowerBi(id) {
        return Service.delete(`/api/power-bi/` + id)
            // {}, {
            // headers: { Authorization: `Bearer ${data.token}` }
        // });
    }

};

export default powerBi;
